import React from 'react'
import barrenPayLightLogo from "../../../assets/images/barrenPay-LightLogo.png"
import { Link } from "react-router-dom";

function MobileNav() {
    const [showMenuIcon, setshowMenuIcon] = React.useState(false);
    return (
        <header class="sticky top-0 z-50 block md:hidden">
            <div class="py-3 bg-gray-900">
                <div class="container px-4 mx-auto">
                    <div class="flex items-center justify-between">
                        <div class="block -m-2 lg:hidden">
                            <Link to="/account" onClick={(() => { setshowMenuIcon(false) })}>
                                <button type="button" class="inline-flex items-center justify-center p-2 text-white bg-gray-900 rounded-md hover:text-white hover:bg-gray-800">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
                                    </svg>
                                </button>
                            </Link>
                        </div>

                        <div class="flex-shrink-0 ml-2 mr-4 lg:ml-0">
                            <Link to="/account" onClick={(() => { setshowMenuIcon(false) })}>
                                <a title="" class="flex items-center">
                                    <img class="block w-auto h-8" src={barrenPayLightLogo} alt="" />
                                </a>
                            </Link>
                        </div>

                        <div class="flex-1 max-w-xs ml-auto lg:hidden">
                            <label for="" class="sr-only"> Search </label>
                        </div>

                        <div class="flex items-center ml-4 lg:ml-0">
                        <button type="button" class="inline-flex items-center justify-center p-2 text-white">
                                
                            {!showMenuIcon &&
                                <span aria-hidden="true" onClick={() => { setshowMenuIcon(true) }}>
                                    <svg className="w-7 h-7" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4 6h16M4 12h16M4 18h16" />
                                    </svg>
                                </span>
                            }

                            {showMenuIcon &&
                                <span aria-hidden="true" onClick={() => { setshowMenuIcon(false) }}>
                                    <svg className="w-7 h-7" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </span>
                            }
                            </button>
                        </div>
                    </div>

                    {showMenuIcon &&
                    <nav x-show="expanded" x-collapse>
                        <div className="px-1 my-5 text-center">
                            <div className="grid gap-y-7">

                                <Link to="/account" onClick={(() => { setshowMenuIcon(false) })}>
                                    <a title="" className="text-base font-medium text-white transition-all duration-200 font-pj hover:text-opacity-50  focus:ring-gray-900 focus:ring-offset-2">
                                        Home
                                    </a>
                                </Link>

                                <Link to="/account/cards" onClick={(() => { setshowMenuIcon(false) })}>
                                    <a title="" className="text-base font-medium text-white transition-all duration-200 font-pj hover:text-opacity-50  focus:ring-gray-900 focus:ring-offset-2">
                                        Cards
                                    </a>
                                </Link>

                                <Link to="/account/cards/createnewcard" onClick={(() => { setshowMenuIcon(false) })}>
                                    <a title="" className="text-base font-medium text-white transition-all duration-200 font-pj hover:text-opacity-50  focus:ring-gray-900 focus:ring-offset-2">
                                        Create New Card
                                    </a>
                                </Link>

                                <Link to="/account/dealsandoffers" onClick={(() => { setshowMenuIcon(false) })}>
                                    <a title="" className="text-base font-medium text-white transition-all duration-200 font-pj hover:text-opacity-50  focus:ring-gray-900 focus:ring-offset-2">
                                        Discount Deals and Offers
                                    </a>
                                </Link>

                                <Link to="/account/settings" onClick={(() => { setshowMenuIcon(false) })}>
                                    <a title="" className="text-base font-medium text-white transition-all duration-200 font-pj hover:text-opacity-50  focus:ring-gray-900 focus:ring-offset-2">
                                        Account Settings
                                    </a>
                                </Link>

                                <Link to="/account/signout" onClick={(() => { setshowMenuIcon(false) })}>
                                    <a title="" className="text-base font-medium text-white transition-all duration-200 font-pj hover:text-opacity-50  focus:ring-gray-900 focus:ring-offset-2">
                                        Sign Out
                                    </a>
                                </Link>
                            </div>
                        </div>
                    </nav>
                }
                </div>
            </div>
        </header>
    )
}

export default MobileNav